// Mock data for Streetsville Eyecare website

export const heroImages = [
  // 1. Stylish woman with round sunglasses
  'https://images.unsplash.com/photo-1628682819336-3d52f343173d?w=1920&q=80',
  // 2. Man with glasses in fall coat with autumn leaves
  'https://images.pexels.com/photos/9929717/pexels-photo-9929717.jpeg?auto=compress&cs=tinysrgb&w=1920',
  // 3. Woman holding/adjusting glasses
  'https://images.pexels.com/photos/4491436/pexels-photo-4491436.jpeg?auto=compress&cs=tinysrgb&w=1920',
  // 4. Blonde woman with sunglasses in wheat field
  'https://images.pexels.com/photos/583124/pexels-photo-583124.jpeg?auto=compress&cs=tinysrgb&w=1920',
  // 5. Actual store - geometric sunglasses wall display
  'https://customer-assets.emergentagent.com/job_929915db-def1-4d81-a6ce-06dd0e5d42cf/artifacts/qzj9uqp6_8a1482ac-8107-4d84-a55e-6b92073f6384.jpg',
  // 6. Actual store - frame displays (new photo)
  'https://customer-assets.emergentagent.com/job_929915db-def1-4d81-a6ce-06dd0e5d42cf/artifacts/tfow5fcu_8c20f886-4c1e-4ea5-9fac-7498c7f8c09d.jpg'
];

export const businessInfo = {
  name: 'Streetsville Eyecare',
  tagline: 'Optometrist & Eyeglasses Streetsville, Mississauga',
  description: 'Specializing in custom lenses and boutique designer glasses not found anywhere else!',
  phone: '(289) 652-1682',
  email: 'streetsvilleeyecare@gmail.com',
  address: {
    street: '128 Queen Street South',
    unit: 'Unit #21',
    city: 'Mississauga',
    province: 'Ontario',
    postalCode: 'L5M 1K8'
  },
  hours: [
    { day: 'Monday', hours: '10:00 am - 6:00 pm' },
    { day: 'Tuesday', hours: '10:00 am - 6:00 pm' },
    { day: 'Wednesday', hours: '10:00 am - 6:00 pm' },
    { day: 'Thursday', hours: '11:30 am - 7:00 pm' },
    { day: 'Friday', hours: '10:00 am - 6:00 pm' },
    { day: 'Saturday', hours: '10:00 am - 4:00 pm' },
    { day: 'Sunday', hours: 'Closed' }
  ],
  social: {
    instagram: 'https://www.instagram.com/streetsvilleeyecare/',
    facebook: 'https://www.facebook.com/StreetsvilleEyecare/',
    linkedin: 'https://www.linkedin.com/company/streetsville-eyecare',
    yelp: 'https://www.yelp.com/biz/streetsville-eye-care-mississauga'
  }
};

export const services = [
  {
    id: 1,
    title: 'On-Site Eye Exams',
    description: 'Eye exams done on premises. Contact us to book your appointment today.',
    icon: 'Eye',
    image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=800&q=80'
  },
  {
    id: 2,
    title: 'Custom Fit Eyeglasses',
    description: 'Exclusive trendy & designer frames everyone from kids to seniors at affordable prices.',
    icon: 'Glasses',
    image: 'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?w=800&q=80'
  },
  {
    id: 3,
    title: 'Custom Fit Sunglasses',
    description: 'Custom fit prescription and non-prescription sunglasses available on site.',
    icon: 'Sun',
    image: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=800&q=80'
  },
  {
    id: 4,
    title: 'On-Site Glasses Repairs',
    description: 'We do major and minor glasses repairs on site while you wait. Book an appointment now.',
    icon: 'Wrench',
    image: 'https://images.pexels.com/photos/5715901/pexels-photo-5715901.jpeg?auto=compress&cs=tinysrgb&w=1920&q=80'
  },
  {
    id: 5,
    title: 'Contact Lenses Sold On Site',
    description: 'Regular, disposable, daily, weekly, monthly, coloured and bifocal contact lenses available.',
    icon: 'Contact',
    image: 'https://images.pexels.com/photos/5843438/pexels-photo-5843438.jpeg?auto=compress&cs=tinysrgb&w=1920&q=80'
  },
  {
    id: 6,
    title: 'Special Needs Optician',
    description: 'If you are a senior OR have a physical disability and are unable to come in-store, please contact us to arrange other options so we may accomodate you.',
    icon: 'Heart',
    image: 'https://images.unsplash.com/photo-1633158832433-11a30ad1e10d?w=1920&q=80'
  }
];

export const features = [
  {
    id: 1,
    title: 'Personal Service',
    description: 'Get fit for the perfect frames by our very own Optician & Fashion Designer, Dil Kalsi.',
    icon: 'User'
  },
  {
    id: 2,
    title: 'Elegant & Stylish',
    description: 'Discover the ideal frames for you from our handpicked collection of sophisticated & fashionable eyewear.',
    icon: 'Sparkles'
  },
  {
    id: 3,
    title: 'Designer Brands',
    description: 'We specialize in boutique designer frames from all over the world: Italy, Paris, England & Canada.',
    icon: 'Award'
  }
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://images.unsplash.com/photo-1574258495973-f010dfbb5371?w=800&q=80',
    title: 'Designer Collection',
    photographer: 'Studio Collection'
  },
  {
    id: 2,
    url: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80',
    title: 'Boutique Display',
    photographer: 'Store Gallery'
  },
  {
    id: 3,
    url: 'https://images.unsplash.com/photo-1509695507497-903c140c43b0?w=800&q=80',
    title: 'Elegant Frames',
    photographer: 'Fashion Collection'
  }
];

export const promotion = {
  discount: '20% OFF',
  title: 'Back to School Sale!!',
  description: 'Join the sale event now and get a pair for a discount (or two) before they are all gone.',
  endDate: 'Monday September 30, 2024'
};

export const aboutText = {
  heading: 'Serving Streetsville and Mississauga For Over 52 Years!',
  description: 'Currently owned and operated by Dil Kalsi, Streetsville Eyecare has been a reputable establishment since 1974 and offers the best in eye care service and technology in a warm and comfortable environment. Ms Kalsi is a registered optician and a trained fashion designer and is able to provide her clients with excellent feedback to ensure they get the glasses that not only improve their vision but also suit their personal style and the shape of their face.'
};

export const quote = {
  text: 'Life Is Too Short To Walk Around With Boring Frames',
  author: 'Dil Kalsi'
};

export const newArrivals = {
  title: 'Come check out our New Arrivals',
  items: [
    'CCS Frames-infused with 24kt Gold, slip into a reverie of flowers, feathers and crystalline acetates',
    'Genesis eyewear is artwear inspired by pop'
  ]
};
